// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__22IZd","footer":"ReportModalFilter_footer__mC1-T"};